import { createAction, props } from '@ngrx/store';

export const setIsSidebar = createAction('[System] Set Is Sidebar', props<{ isSidebar: boolean }>());

export const setFacebookConfig = createAction(
  '[System] Set Facebook Config',
  props<{ appId: string; configId: string }>()
);
